import React, { useState } from 'react';
import { Button, Col, Form, Tooltip, Input, Row } from 'antd';
import { MinusCircleFilled, MinusCircleOutlined, PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import UniDropAdv from '../components/ReportFormGenerator/UniDrop/UniDropAdv';
import ZenFormInput from './InputCreater/ZenFormInput';
const { TextArea } = Input;


const InternalPage = ({
    urlData
}) => {
    const [form] = Form.useForm();
    const modalElements = [
        {
            "typ": "textBox",
            "visible": true,
            "data_index": "Obj",
            'textWrap': true,
            'rows': 4,
            "default": null,
            "label": "Objective",
            "labelColSpan": 10,
            "required": true,
            "colSize": 12
        },
        {
            "typ": "intControl",
            "visible": true,
            "data_index": "margin",
            "default": 0,
            "label": "Tab (Margin)",
            "labelColSpan": 10,
            "required": true,
            "colSize": 12
        },
        {
            "typ": "dropDown",
            "visible": true,
            "default": null,
            "multiSelect": false,
            "includeAll": true,
            "required": true,
            "placeHolder": "Select Employee ",
            "errorMessage": "Please select  Employee",
            "readOnly": false,
            "data_index": "collection",
            "p_data_index": "p_collection",
            "label": "Collection",
            "labelColSpan": 10,
            "source": "mdict",
            "sourceParams": {
                "typ": "Employee",
                "subTyp": "idame"
            },
            "colSize": 12
        },
        {
            "typ": "dropDown",
            "visible": true,
            "default": null,
            "multiSelect": false,
            "includeAll": true,
            "required": true,
            "placeHolder": "Select Employee ",
            "errorMessage": "Please select  Employee",
            "readOnly": false,
            "data_index": "key",
            "p_data_index": "p_key",
            "label": "Key",
            "labelColSpan": 10,
            "source": "mdict",
            "sourceParams": {
                "typ": "Employee",
                "subTyp": "idame"
            },
            "colSize": 12
        },
        {
            "typ": "textBox",
            "visible": true,
            "data_index": "filter",
            'textWrap': true,
            'rows': 4,
            "default": null,
            "label": "Filter Criteria",
            "labelColSpan": 10,
            "required": true,
            "colSize": 24
        },
        {
            "typ": "textBox",
            "visible": true,
            "data_index": "rmrks",
            'textWrap': true,
            'rows': 4,
            "default": null,
            "label": "Remarks",
            "labelColSpan": 10,
            "required": true,
            "colSize": 24
        },
        {
            "typ": "textBox",
            "visible": true,
            "data_index": "otpt",
            'textWrap': true,
            'rows': 4,
            "default": null,
            "label": "Output",
            "labelColSpan": 10,
            "required": true,
            "colSize": 24
        },
    ]
    const [blocks, setBlocks] = useState(
        [
            {
                'indx': 0,
                modalElements
            }
        ]
    );
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
    const LocalDict = [];
    const blockForm = [];
    const onFinish = (values) => {
        console.log(values);
    }


    const queryElements = (controls, indx) => {
        return (<Row>
            {
                controls.map((data, index) => {
                    if (dtArray.includes(data["typ"])) {

                        LocalDict[data["data_index"]] = data["format"]
                            ? data["format"]
                            : "YYYY-MM-DD hh:mm:ss";
                        LocalDict["data_index_from"] = data["data_index_from"];
                        LocalDict["data_index_to"] = data["data_index_to"];
                    }

                    if (data.visible) {
                        return (
                            <React.Fragment key={index}>
                                <ZenFormInput
                                    urlData={{ ...urlData }}
                                    childType={data.childType}
                                    pageType={"zenForm"}
                                    header={data.header}
                                    footer={data.footer}
                                    labelColSpan={data["labelColSpan"]}
                                    style={data['style']}
                                    height={data['height']}
                                    layoutPosition="space-between"
                                    form={form}
                                    LocalDict={LocalDict}
                                    rows={data.rows}
                                    colSpan={data.colSize}
                                    name={`data[${indx}]${data["data_index"]}`}
                                    label={data["label"]}
                                    defaultValue={data["default"]}
                                    typ={data["typ"]}
                                    disabled={data["readOnly"]}
                                    source={data["source"]}
                                    sourceParams={data["sourceParams"]}
                                    auxParams={data["auxParams"]}
                                    format={data["format"]}
                                    errorMessage={data["errorMessage"]}
                                    placeHolder={data["placeHolder"]}
                                    required={data["required"]}
                                    options={data["data"]}
                                    from={data["data_index_from"]}
                                    to={data["data_index_to"]}
                                    url={data["url"]}
                                    includeAll={data["includeAll"]}
                                    pname={`data[${indx}]${data["p_data_index"]}`}
                                    defaultFrom={data["defaultFrom"]}
                                    defaultTo={data["defaultTo"]}
                                    multiSelect={data["multiSelect"]}
                                    searchable={data["isSearchable"]}
                                    data={data}
                                    // extraData={extraData}
                                    children={data['children']}
                                />
                            </React.Fragment>
                        );
                    }
                })}
        </Row>)
    }


    const addNewBlock = (indx) => {
        setBlocks([...blocks, { indx, modalElements }])
    }


    return (
        <div className={'customer-complaint'} style={{ padding: "10px" }}>
            <div className="customer-form">
                <Form
                    name="ReportForm"
                    labelWrap={true}
                    form={form}
                    labelCol={{ span: 8 }}
                    layout={"vertical"}
                    colon={false}
                    onFinish={onFinish}
                    size="large"
                >
                    {
                        blocks.map((block, blockIndex) => (
                            <div className="container-fluid" key={blockIndex} style={{
                                border: '1px solid #ffffff',
                                padding: 5,
                                borderRadius: 10,
                                width: '50%',
                                marginBottom: 10,
                                marginLeft: parseInt(form.getFieldValue(`data[${blockIndex}]margin`))
                            }}>
                                {(blockIndex + 1) === blocks.length ?
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                        <Tooltip title="Add New" color="geekblue">
                                            <Button
                                                icon={<PlusCircleFilled />}
                                                type="link" onClick={() => addNewBlock(blockIndex + 1)}>{''}</Button>

                                        </Tooltip>
                                        <Tooltip title="Delete" color="geekblue">
                                            <Button
                                                icon={<MinusCircleFilled />}
                                                type="link" onClick={() => setBlocks(blocks - 1)}>{''}</Button>
                                        </Tooltip>
                                    </div>
                                    : <></>}
                                {queryElements(block.modalElements, blockIndex)}
                            </div>
                        ))
                    }
                    <Button htmlType='submit' type='primary' size='large'>Submit</Button>
                </Form>
            </div>
        </div>
    )
};

export default InternalPage;